import "./RentalExposureIndex.module.css";
import Header from "@/reusable_sections/Header";
import DownloadResourcesGrid from "./sections/DownloadResourcesGrid";
import RealTimeWinRateLeaderboard from "./sections/RealTimeWinRateLeaderboard";
import TheStrategicContext from "./sections/TheStrategicContext";
import SubscribeMediaEnquiry from "./sections/SubscribeMediaEnquiry";
import Footer from "@/reusable_sections/Footer";
export default function RentalExposureIndexPage() {
  return <div>
      <Header />
      <DownloadResourcesGrid />
      <RealTimeWinRateLeaderboard />
      <TheStrategicContext />
      <SubscribeMediaEnquiry />
      <Footer />
    </div>;
}